if (!customElements.get('livapur-posture-gallery')) {
  customElements.define(
    'livapur-posture-gallery',
    class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.addEventListener('click', (event) => {
          const button = event.target.closest('button[data-image]');
          if (!button || !this.contains(button)) return;

          const main = this.querySelector('.lpn-gallery__main');
          const fullLink = this.querySelector('.lpn-gallery__stage');
          const thumbnail = button.querySelector('img');
          if (!main || !fullLink || !thumbnail) return;

          this.querySelectorAll('button[data-image]').forEach((item) => {
            item.setAttribute('aria-pressed', String(item === button));
          });

          main.classList.add('is-changing');
          main.addEventListener('load', () => main.classList.remove('is-changing'), { once: true });
          main.src = button.dataset.image;
          main.alt = thumbnail.alt;
          fullLink.href = button.dataset.full;
        });
      }
    }
  );
}

document.querySelectorAll('[data-lpn-story]').forEach((story) => {
  if (story.dataset.lpnReady === 'true') return;
  story.dataset.lpnReady = 'true';

  const items = story.querySelectorAll('[data-lpn-reveal]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduceMotion || !('IntersectionObserver' in window)) {
    items.forEach((item) => item.classList.add('is-visible'));
    return;
  }

  story.classList.add('lpn-reveal-ready');
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -4% 0px' }
  );

  items.forEach((item) => observer.observe(item));
});
